/* NODGRID FX
   1. オープニング（グリッチ）… 0.8秒・初回のみ・いつでもスキップ可
   2. FV … ゆっくり寄るズーム ＋ スクロールのパララックス
   読み込みを一切ブロックしない（defer で読み、失敗しても本体は動く） */
(function () {
  'use strict';

  var REDUCED =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KEY = 'ng_intro_seen';
  var DURATION = 1600; // ms（幕が開き始めるまで）
  var CURTAIN = 640;   // ms（幕が開ききるまで）

  /* ---------- 1. オープニング ---------- */
  function intro() {
    var el = document.getElementById('ng-intro');
    if (!el) return;

    var seen = false;
    try {
      seen = sessionStorage.getItem(KEY) === '1';
    } catch (e) {
      /* プライベートモード等では毎回表示になるだけ。実害なし */
    }

    var root = document.documentElement;

    // 確認用パラメータ
    //   ?ng_intro=1   … 何度でもオープニングを見る（初回判定を無視）
    //   ?ng_nointro=1 … オープニングを出さない（スクショ撮影用）
    var skipParam = false;
    var forceParam = false;
    try {
      var q = new URLSearchParams(location.search);
      skipParam = q.has('ng_nointro');
      forceParam = q.has('ng_intro');
    } catch (e) {}
    if (forceParam) seen = false;

    if (REDUCED || (seen && !forceParam) || skipParam) {
      el.remove();
      root.classList.add('ng-revealed');
      return;
    }

    root.classList.add('ng-intro-lock');

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      try {
        sessionStorage.setItem(KEY, '1');
      } catch (e) {}
      root.classList.remove('ng-intro-lock');
      // 幕を割る → 開ききってから FV の文字を立ち上げる
      el.classList.add('ng-intro--out');
      window.setTimeout(function () {
        root.classList.add('ng-revealed');
      }, 180);
      window.setTimeout(function () {
        if (el.parentNode) el.remove();
      }, CURTAIN + 80);
      off();
    }

    var EVENTS = ['pointerdown', 'wheel', 'touchstart', 'keydown'];
    function off() {
      EVENTS.forEach(function (t) {
        window.removeEventListener(t, finish, { passive: true });
      });
    }
    EVENTS.forEach(function (t) {
      window.addEventListener(t, finish, { passive: true });
    });

    window.setTimeout(finish, DURATION);
    // 保険：何かが詰まっても必ず消す
    window.setTimeout(function () {
      if (el.parentNode) {
        root.classList.remove('ng-intro-lock');
        root.classList.add('ng-revealed');
        el.remove();
      }
    }, 4000);
  }

  /* ---------- 2. 動かすセクション（FV と VOID） ---------- */
  function moveSections() {
    if (REDUCED) return;
    var main = document.querySelector('main[data-template^="index"]');
    if (!main) return;

    var sections = main.querySelectorAll('.shopify-section');
    var targets = [];

    var first = sections[0];
    if (first) {
      first.classList.add('ng-hero', 'ng-move');
      targets.push({ el: first, amp: 70 });
    }

    // VOID（テーマコレクション）。id が変わっても拾えるよう保険をかける
    var voidSec =
      document.getElementById('shopify-section-theme_collection') ||
      main.querySelector('.shopify-section[id*="theme_collection"]');
    if (voidSec && voidSec !== first) {
      voidSec.classList.add('ng-move', 'ng-move--soft');
      targets.push({ el: voidSec, amp: 44 });
    }
    if (!targets.length) return;

    // 画面に入ったら動き出す
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) e.target.classList.add('is-in');
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
      );
      targets.forEach(function (t) {
        io.observe(t.el);
      });
    } else {
      targets.forEach(function (t) {
        t.el.classList.add('is-in');
      });
    }

    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || 1;
      targets.forEach(function (t) {
        var r = t.el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return; // 画面外は計算しない
        // -1（画面下）〜 1（画面上）
        var prog = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        t.el.style.setProperty('--ng-par', (-prog * t.amp).toFixed(1) + 'px');
      });
    }
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---------- 3. スクロールで要素がフワッと出る ---------- */
  function reveal() {
    if (REDUCED || !('IntersectionObserver' in window)) return;

    var main = document.querySelector('main');
    if (!main) return;
    var sections = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
    if (!sections.length) return;

    // 「同じタグの子が3つ以上」＝グリッドとみなす。ul/li に限定しない
    function findGrid(sec) {
      var best = null, bestN = 0;
      var all = sec.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var kids = all[i].children;
        if (kids.length < 3 || kids.length > 24) continue;
        var tag = kids[0].tagName, same = true;
        for (var j = 1; j < kids.length; j++) {
          if (kids[j].tagName !== tag) { same = false; break; }
        }
        if (same && kids.length > bestN) { best = all[i]; bestN = kids.length; }
      }
      return best;
    }

    var items = [];
    sections.forEach(function (sec, idx) {
      if (idx === 0 || sec.classList.contains('ng-hero')) return; // FVは幕開けで演出済み
      var grid = findGrid(sec);
      if (grid) {
        Array.prototype.forEach.call(grid.children, function (kid, j) {
          kid.classList.add('ng-reveal');
          kid.style.setProperty('--ng-delay', Math.min(j, 8) * 70 + 'ms');
          items.push(kid);
        });
        var head = sec.querySelector('h1, h2, h3');
        if (head && !grid.contains(head)) { head.classList.add('ng-reveal'); items.push(head); }
      } else {
        sec.classList.add('ng-reveal');
        items.push(sec);
      }
    });
    if (!items.length) return;

    function show(el) {
      el.classList.add('is-shown');
      window.setTimeout(function () { el.classList.add('is-done'); }, 1200);
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          show(e.target);
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
    );
    items.forEach(function (el) { io.observe(el); });

    // 初期表示：すでに画面内にあるものは即座に出す（読み込み直後の空白を防ぐ）
    function initial() {
      var vh = window.innerHeight || 0;
      items.forEach(function (el) {
        if (el.classList.contains('is-shown')) return;
        var r = el.getBoundingClientRect();
        if (r.top < vh * 1.1 && r.bottom > -50) { show(el); io.unobserve(el); }
      });
    }
    initial();
    window.setTimeout(initial, 400);
    // 最終保険：5秒経っても隠れたままなら全部出す
    window.setTimeout(function () {
      items.forEach(function (el) { el.classList.add('is-shown', 'is-done'); });
    }, 5000);
  }
  function boot() {
    try {
      intro();
    } catch (e) {}
    try {
      moveSections();
    } catch (e) {}
    try {
      reveal();
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
